import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';
import type { DisciplineWithCourses } from '@/lib/types';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

export function useGetDisciplines() {
	return useQuery<DisciplineWithCourses[]>({
		queryKey: ['get-all-disciplines', schoolId],

		queryFn: async () => {
			const { data, error } = await supabase
				.from('disciplines')
				.select(
					`
					id,
					name,
					philosophy,
					color,
					image,
					courses_disciplines (
						courses_disciplines_id,
						course_id,
						discipline_id
					)
				`
				)
				.eq('school_id', schoolId)
				.order('name', { ascending: true });

			if (error) throw error;

			return (data ?? []) as unknown as DisciplineWithCourses[];
		},

		staleTime: Infinity,
		refetchOnMount: false,
	});
}
